function TitleWord(word: string) {
  return word?.[0].toUpperCase() + word.slice(1);
}

export function capitalizeFirstLetter(str: any) {
  if (!str) return "";
  return str
    .split(" ") // Split the string by spaces into an array of words
    .map(
      (word: any) =>
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase() // Capitalize first letter and lowercase the rest
    )
    ?.join(" "); // Join the words back into a single string
}
export default TitleWord;
